import { render, staticRenderFns } from "./Koutu_Price.vue?vue&type=template&id=03c2bfd4&scoped=true"
import script from "./Koutu_Price.vue?vue&type=script&lang=js"
export * from "./Koutu_Price.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Price.vue?vue&type=style&index=0&id=03c2bfd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2bfd4",
  null
  
)

export default component.exports